<template>
  <CmLineSidebar
    v-if="info"
    class="loyalty-entity-default-info"
    :class="{
      'loyalty-entity-default-info-open':
        selectedEntity.length === 0 ||
        (isEditMode && allSections && allSections.length === 0)
    }"
  >
    <template v-for="(section, index) in sections">
      <h4
        :key="index"
        class="cm-title"
      >
        {{ $t(`loyalty.sections.${section.name}`) }}
      </h4>
      <div
        :key="'A' + index"
        class="loyalty-entity-default-info__data"
      >
        <card
          v-if="section.card"
          :number="info.attributes['Name']"
          :type="info.attributes['AwardType']"
          :status="info.attributes['Status']"
        />
        <template v-for="(field, index_y) in section.fields">
          <Field
            v-if="!field.required || info.attributes[field.required] === true"
            :key="index_y"
            v-model="info.attributes[field.name]"
            :config="field"
            :checkValue="vObj.info.attributes[field.name]"
            :isEditMode="isEditMode"
          />
        </template>
      </div>
    </template>

    <div v-if="cardBalanceValues.length !== 0">
      <div
        v-for="(section, i) in cardBalanceSections"
        :key="i"
        class="loyalty-entity-default-info__section"
      >
        <h4 class="cm-title">
          {{ $t(`loyalty.sections.${section.title}`) }}
        </h4>
        <div
          v-for="(item, index) in section.content"
          :key="index + item"
          class="client-info__general-row"
        >
          <Field
            v-model="cardBalanceValues[item]"
            :config="cardBalanceAttributes[item]"
            :isEditMode="false"
          />
        </div>
      </div>
    </div>
  </CmLineSidebar>
</template>

<script>
import CmLineSidebar from "@/components/library/CmLineSidebar.vue";
import Card from "@/components/loyalty/components/Card.vue";
import Field from "@/components/loyalty/components/field/Index.vue";
import {mapState} from "vuex";
import LoyaltyService from "@/services/LoyaltyService";

export default {
  name: "LoyaltyEntityInfoCard",

  components: {
    CmLineSidebar,
    Card,
    Field,
  },

  props: {
    vObj: Object,
  },

  data() {
    return {
      cardBalanceSections: [
        {
          "title": "purchases",
          "content": ["Sum", "AllDiscountedSum", "SumAfterDiscounted", "Discount", "Quantity", "AverageCheque", "AverageChequeAfterDiscounted", "LastTransactionOn"],
        },
        {
          "title": "bonusBalance",
          "content": ["Debet", "Credit", "Balance", "ActiveBalance", "HoldPoints"],
        },
        {
          "title": "statusBonusBalance",
          "content": ["StatusDebet", "StatusCredit", "StatusBalance", "StatusActiveBalance", "HoldStatusPoints"],
        },
        {
          "title": "moneyBalance",
          "content": ["MoneyDebet", "MoneyCredit", "MoneyBalance"],
        },
      ],
      cardBalanceAttributes: [],
      cardBalanceValues: [],
    };
  },

  computed: {
    ...mapState({
      allFields: state => state.loyalty.allFields,
      allSections: state => state.loyalty.allSections,
      generalSection: state => state.loyalty.generalSection,
      info: state => state.loyalty.info,
      isEditMode: state => state.loyalty.isEditMode,
      selectedEntity: state => state.loyalty.selectedEntity,
    }),

    sections() {
      return this.allSections && this.allSections ?
        [
          {
            name: 'general',
            card: true,
            fields: this.allFields.filter(item => ['CardTypeId'].includes(item.name)),
          },
          {
            ...this.allSections.find(item => item.name === "affiliations"),
            fields: this.allFields.filter(item => ['ContactId', 'LevelId', 'CollaborationType', 'MasterAccountId', 'PartnerId', 'ShopId'].includes(item.name)),
          },
          {
            ...this.allSections.find(item => item.name === "timeOfAction"),
            fields: this.allFields.filter(item => this.allSections.find(item => item.name === "timeOfAction").generalConfig.map(i => i.name).includes(item.name)),
          },

        ]
        : [];
    },

    fields() {
      return this.allFields.filter(field => this.generalSection.find(i => i.name === field.name))
        .map(field => ({
          ...field,
          ...this.generalSection.find(i => i.name === field.name),
        }))
        .filter(i => i.order)
        .sort((a,b) => a.order - b.order);
    },
  },

  mounted() {
    this.getCardBalanceSectionsInfo();
  },

  methods: {
    async getCardBalanceSectionsInfo() {
      try {
        const metaData = await LoyaltyService.getEntityMetaData('CardBalance');
        this.cardBalanceAttributes = metaData.attributes;

        this.cardBalanceSections.forEach(section => {
          section.content.forEach(field => {
            this.$set(this.cardBalanceAttributes, field, {
              ...this.cardBalanceAttributes[field],
              label: 'ContactBalance' + field,
            });
          });
        });

        const {id} = this.$route.params;
        const contactBalance = await LoyaltyService.getRelationships('Card', id, 'CardBalance', 'CardId', 0, '');
        this.cardBalanceValues = contactBalance[0].attributes;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss">
.loyalty-entity-default-info {
  padding: 15px 0 15px 20px;
  width: 420px;

  &-open {
    width: 100% !important;
    max-width: 100% !important;
  }

  &__data {
    padding-right: 45px;
  }

  &__section {
    margin-top: 30px;
  }

  .cm-line-sidebar__title {
    transform: rotate(270deg) translate(-80px,-45px);
  }
  .cm-title {
    margin-top: 0;
    margin-bottom: 23px;
  }
  &.cm-line-sidebar--closed {
    padding: 0;
  }

  .card-img {
    margin-bottom: 20px;
  }
}
</style>
